import CreditCardIcon from '@mui/icons-material/CreditCard';

import i18n from 'FRONTEND/utils/i18n';

export const getPaymentSupport = () => {
  return {
    title: i18n._('How to activate payment?'),
    text: '',
    paragraphList: [
      {
        title: i18n._('Activate payment'),
        text: i18n._('If the practitioner has set up billing, the payment is then automatically activated with the amount they have predefined. ' +
          'However, you can deactivate the payment if the patient is reimbursed 100%, and modify the amount if necessary.'),
        icon: CreditCardIcon,
      },
    ],
  };
};
